export enum FormControlNames {
    GeneratedSummary = 'generatedSummary',
    Suggestion = 'suggestion',
    Score = 'score',
    LinkedRealEstateAgents = 'linkedRealEstateAgents',
    Location = 'location',
    Sentiment = 'sentiment',
    AssessedTo = 'assessedTo',
}
